import React from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarAccount from "./NavbarAccount";

const PublicNavbar = () => {
  let location = useLocation();

  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-primary w-100 color mt-0  navbar-top"
        // data-bs-theme="dark"
      >
        <div className="container">
          <div className="d-flex flex-row  d-lg-none">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <Link className="navbar-brand" to="/">
            <img src={"/logo_white.svg"} alt="Curso.run" className="me-2" />
            <img src={"/curso_white.png"} alt="Curso.run" />
          </Link>
          <div className="d-flex flex-row  d-lg-none">
            <NavbarAccount />
          </div>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/"
                >
                  Accueil
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname.indexOf("/features") !== -1
                      ? "active"
                      : ""
                  }`}
                  to="/features"
                >
                  Fonctionnalités
                </Link>
              </li>
            </ul>
          </div>
          <div className="d-flex flex-row d-none d-lg-flex">
            <NavbarAccount />
          </div>
        </div>
      </nav>
    </>
  );
};

export default PublicNavbar;
